module.exports = __webpack_public_path__ + "images/interview-Bank_of_America-2.svg";